import { AuthService } from './authService';

export interface UserProfileDetails {
  id: number;
  name: string;
  email: string;
  phone: string;
  location: string;
  bio: string;
  avatar?: string;
  created_at?: string;
  subscription_status?: string;
}

export interface UserProfileStats {
  user_id: number;
  username: string;
  join_date: string;
  last_login: string;
  email_verified: boolean;
  preferred_language: string;
  total_conversations: number;
  paid_analyses: number;
  subscription_type: string;
}

export interface UserProfileUpdateRequest {
  name?: string;
  phone?: string;
  location?: string;
  bio?: string;
}

const USER_API_BASE = process.env.REACT_APP_AUTH_API_BASE || 'http://localhost:9001';

export class UserService {
  private static getAuthHeaders(): HeadersInit {
    const token = localStorage.getItem('access_token');
    return {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` })
    };
  }

  /**
   * 获取用户详细资料
   */
  static async getUserProfileDetails(): Promise<UserProfileDetails> {
    const response = await fetch(`${USER_API_BASE}/api/v1/users/profile/details`, {
      method: 'GET',
      headers: this.getAuthHeaders()
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || '获取用户详细资料失败');
    }

    return response.json();
  }

  /**
   * 获取用户统计信息
   */
  static async getUserProfileStats(): Promise<UserProfileStats> {
    const response = await fetch(`${USER_API_BASE}/api/v1/users/stats`, {
      method: 'GET',
      headers: this.getAuthHeaders()
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || '获取用户统计信息失败');
    }

    return response.json();
  }

  /**
   * 更新用户详细资料
   */
  static async updateUserProfileDetails(data: UserProfileUpdateRequest): Promise<UserProfileDetails> {
    const response = await fetch(`${USER_API_BASE}/api/v1/users/profile/details`, {
      method: 'PATCH',
      headers: this.getAuthHeaders(),
      body: JSON.stringify(data)
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || '更新用户详细资料失败');
    }

    return response.json();
  }

  /**
   * 上传用户头像
   */
  static async uploadAvatar(file: File): Promise<{ avatar_url: string }> {
    const formData = new FormData();
    formData.append('avatar', file);

    const response = await fetch(`${USER_API_BASE}/api/v1/users/profile/avatar`, {
      method: 'POST',
      headers: {
        Authorization: `Bearer ${localStorage.getItem('access_token')}`
      },
      body: formData
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.detail || '头像上传失败');
    }

    return response.json();
  }
} 